import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';
import * as evaluacionService from "../../services/evaluacionService";
import { Grid, Card, CardContent, Snackbar, Alert } from '@mui/material';
import ObjetivoCatalogo from '../../components/ObjetivoCatalogo'
import MantenimientoForm from '../../components/common/MantenimientoForm';
import { useMantenimiento } from '../../hooks/useMantenimiento';
import { activeValidations as activeValidationsObjetivo } from '../../redux/objetivoCatalogoSlice';

// Mantenimiento del catalogo de objetivos: los objetivos que se pueden
// asignar a los participantes, agrupados por tema de evaluacion.
const Edit = () => {
    const objetivo = useSelector((state) => state.objetivoCatalogo.entity);
    const objetivoValidation = useSelector((state) => state.objetivoCatalogo.validationMessage);

    const [openMessage, setOpenMessage] = useState(false)
    const onCloseMessage = () => { setOpenMessage(!openMessage); }
    const [propsMessage, setPropsMessage] = useState({ severity: "success", message: "" });
    const dispatch = useDispatch();
    const params = useParams();
    const { isReadOnly, setIsReadOnly } = useMantenimiento("evaluacion");

    const mensaje = (severity, texto) => {
        setPropsMessage({ severity: severity, message: texto })
        setOpenMessage(true);
    }

    const postEntity = async () => {
        if (objetivoValidation.length > 0) {
            dispatch(activeValidationsObjetivo());
            mensaje("error", objetivoValidation.join(" - "))
            return;
        }

        try {
            await evaluacionService.addUpdateObjetivoCatalogo({
                id: objetivo.id,
                idTemaEvaluacion: objetivo.idTemaEvaluacion,
                nombre: objetivo.nombre,
                descripcion: objetivo.descripcion,
                idEstado: objetivo.idEstado,
            })

            mensaje("success", "Se guardaron los datos con exito")
            setIsReadOnly(true)
        }
        catch (err) {
            console.log("Err: ", err);
            mensaje("error", err?.response?.data?.detail || "Hubo un error al guardar")
        }
    }

    return (
        <div>
            <MantenimientoForm
                title={(parseInt(params.id) === 0 ? "Nuevo" : "Editar") + " Objetivo del Catalogo"}
                backTo={"/objetivocatalogo"}
                onSave={postEntity}
                disabled={isReadOnly}
            >
                <Grid container spacing={1} sx={{
                    "& .MuiGrid-root>.MuiGrid-item": {
                        paddingTop: "8px"
                    },
                }}>
                    <Grid item xs={12} sm={12}>
                        <Card>
                            <CardContent sx={{ padding: "0px 10px 10px 10px !important" }}>
                                <ObjetivoCatalogo isReadOnly={isReadOnly} />
                            </CardContent>
                        </Card>
                    </Grid>
                </Grid>
            </MantenimientoForm>
            <Snackbar open={openMessage} autoHideDuration={5000} onClose={onCloseMessage}
                anchorOrigin={{ vertical: "top", horizontal: "center" }}>
                <Alert onClose={onCloseMessage} severity={propsMessage.severity}>
                    {propsMessage.message}
                </Alert>
            </Snackbar>
        </div>
    )
}

export default Edit
